var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { InputText, Typography, Icon } from "@uigovpe/components";
/**
 * Campo de texto integrado ao React Hook Form de (TextField).
 *
 * @param {string} name - Nome do campo para registro no formulário.
 * @param {string} [label] - Rótulo do campo.
 * @param {string} [placeholder] - Texto de placeholder.
 * @param {string} [type='text'] - Tipo do input (text, email, password, etc.).
 * @param {string} [className] - Classes CSS para o container.
 * @param {boolean} [disabled] - Se verdadeiro, desabilita o campo.
 * @param {RegisterOptions} [rules] - Regras de validação do React Hook Form.
 * @return {JSX.Element} O campo de texto renderizado com tratamento de erro.
 */
export var TextField = function (_a) {
    var name = _a.name, label = _a.label, ariaLabel = _a.ariaLabel, placeholder = _a.placeholder, _b = _a.type, type = _b === void 0 ? "text" : _b, className = _a.className, disabled = _a.disabled, rules = _a.rules;
    var control = useFormContext().control;
    return (_jsx(Controller, { name: name, control: control, rules: rules, render: function (_a) {
            var field = _a.field, error = _a.fieldState.error;
            return (_jsx("div", __assign({ className: className }, { children: _jsxs("div", __assign({ className: "flex flex-col gap-1" }, { children: [_jsx(InputText, __assign({}, field, { label: label, "aria-label": ariaLabel, placeholder: placeholder, type: type, disabled: disabled, className: error ? "p-invalid" : "", "aria-invalid": error ? "true" : "false", "aria-describedby": error ? "".concat(name, "-error") : undefined })), error && (_jsxs("div", __assign({ id: "".concat(name, "-error"), role: "alert", "aria-live": "polite", className: "flex items-center gap-1.5 px-2 py-1.5 bg-red-50 border border-red-200 rounded animate-in slide-in-from-top-1 duration-200" }, { children: [_jsx(Icon, { icon: "error", className: "text-red-600 text-sm shrink-0" }), _jsx(Typography, __assign({ variant: "small", className: "text-red-700 text-xs" }, { children: error.message }))] })))] })) })));
        } }));
};
